import { DateUtil } from 'app/shared/utils/date.util';
import { TranslateService } from '@ngx-translate/core';
import { OnyxEvent } from 'app/event/models/event';
import { ReportType } from './../models/report-type.enum';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { ResponseUtilService } from '../../shared/utils/response-util.service';

@Injectable()
export class ReportService {

  private reportEndpoint: string = this.environment.baseUrl + '/api/events';

  constructor(
    private httpClient: HttpClient,
    private environment: EnvironmentConfiguration,
    private authStore: AuthenticationStore,
    private responseUtilService: ResponseUtilService,
    private translateService: TranslateService
  ) { }

  getReservationsReport(eventId: number, isSummary: boolean, fileType: string): Observable<any> {
    const token = this.authStore.getToken();
    const reportType = isSummary ? 'summary' : 'compare';
    const url = `${ this.reportEndpoint }/${ eventId }/report/reservations/${ reportType }/${ fileType }?Authorization=${ token }`;

    return this.httpClient.get(url, { observe: 'response', responseType: 'blob' })
      .catch(err => this.responseUtilService.handleError(err));
  }

  getPaymentsReport(eventId: number, fileType: string): Observable<any> {
    const token = this.authStore.getToken();
    const url = `${ this.reportEndpoint }/${ eventId }/report/payments/summary/${ fileType }?Authorization=${ token }`;

    return this.httpClient.get(url, { observe: 'response', responseType: 'blob' })
      .catch(err => this.responseUtilService.handleError(err));
  }

  getRsvpReport(eventId: number, fileType: string, summarySelected: boolean): Observable<any> {
    const token = this.authStore.getToken();
    const rsvpType = summarySelected ? 'summary' : 'compare';
    const url = `${ this.reportEndpoint }/${ eventId }/report/rsvp/${ rsvpType }/${ fileType }?Authorization=${ token }`;

    return this.httpClient.get(url, { observe: 'response', responseType: 'blob' })
      .catch(err => this.responseUtilService.handleError(err));
  }

  buildReportFileName(reportType: ReportType, event: OnyxEvent, fileType: string) {
    let reportTypePrefix: string;
    switch (reportType) {
      case ReportType.EVENT_LIST:
        reportTypePrefix = this.translateService.instant('COMMON.REPORT.NAMES.EVENT_LIST');
        break;
      case ReportType.RESERVATION_SUMMARY:
        reportTypePrefix = this.translateService.instant('COMMON.REPORT.NAMES.RESERVATION_SUMMARY');
        break;
      case ReportType.PAYMENT_SUMMARY:
        reportTypePrefix = this.translateService.instant('COMMON.REPORT.NAMES.PAYMENT_SUMMARY');
        break;
      case ReportType.RSVP_SUMMARY:
        reportTypePrefix = this.translateService.instant('COMMON.REPORT.NAMES.RSVP_SUMMARY');
        break;
      case ReportType.RESERVATION_COMPARE:
        reportTypePrefix = this.translateService.instant('COMMON.REPORT.NAMES.RESERVATION_COMPARE');
        break;
      case ReportType.RSVP_COMPARE:
        reportTypePrefix = this.translateService.instant('COMMON.REPORT.NAMES.RSVP_COMPARE');
        break;
      default:
        reportTypePrefix = '';
    }
    const extension = fileType === 'pdf' ? '.pdf' : '.xlsx';
    const groupCode = event ? event.eventProperty.eventReferenceNumber + '_' : '';
    return reportTypePrefix + '_' + groupCode + DateUtil.formatDate(new Date(), 'YYYYMMDD') + extension;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/report.service.ts